import { createContext, useContext, useEffect, useState } from "react";
import { apiGet } from "./api";

const CatalogCtx = createContext({ catalog: null, loading: true, error: null, reload: () => {} });

export function CatalogProvider({ children }) {
  const [state, setState] = useState({ catalog: null, loading: true, error: null });
  const load = () => {
    setState((s) => ({ ...s, loading: true, error: null }));
    apiGet("/catalog")
      .then((catalog) => setState({ catalog, loading: false, error: null }))
      .catch((error) => setState({ catalog: null, loading: false, error }));
  };
  useEffect(load, []);
  return <CatalogCtx.Provider value={{ ...state, reload: load }}>{children}</CatalogCtx.Provider>;
}

export function useCatalog() {
  return useContext(CatalogCtx);
}

export function formatPrice(value, currency, lang) {
  if (value == null) return null;
  try {
    return new Intl.NumberFormat(lang === "fr" ? "fr-FR" : "en-US", {
      style: "currency",
      currency: currency || "EUR",
      maximumFractionDigits: value % 1 === 0 ? 0 : 2,
    }).format(value);
  } catch {
    return `${value} ${currency || ""}`.trim();
  }
}

export function formatDate(iso, lang) {
  if (!iso) return "";
  try {
    return new Intl.DateTimeFormat(lang === "fr" ? "fr-FR" : "en-US", {
      day: "numeric",
      month: "long",
      year: "numeric",
    }).format(new Date(iso));
  } catch {
    return iso;
  }
}
